import * as React from 'react';

import classnames from 'classnames';

import {RadioGroupContext} from './radio-group';

import styles from '../checkbox/checkbox-button.module.css';

type Props = {
    disabled?: boolean;
    value: string;
    isLarge?: boolean;
    children?: React.ReactNode;
};

export class RadioButton extends React.Component<Props> {
    render() {
        const styleNames = classnames(styles['input-button'], {
            [styles['is-large']]: this.props.isLarge,
        });

        return (
            <RadioGroupContext.Consumer>
                {({name, selectedValue, onChange}) => {
                    const checked = this.props.value === selectedValue;
                    const radioId = `${name}-${this.props.value}`;

                    return (
                        <div className={styleNames}>
                            <input
                                id={radioId}
                                name={name}
                                type='radio'
                                role='radio'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(e) => this.handleChange(e, onChange)}
                            />
                            <label htmlFor={radioId}>{this.props.children}</label>
                        </div>
                    );
                }}
            </RadioGroupContext.Consumer>
        );
    }

    handleChange = (e: React.ChangeEvent<any>, onChange: (...args: any) => any) => {
        e.stopPropagation();

        onChange(this.props.value);
    };
}
